
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { loadConfig } from "../helpers/config";
import LoadingSpinner from "../components/LoadingSpinner";

function Checks() {
  let navigate = useNavigate();
  const [ChecksObject, setChecksObject] = useState([]);
  const [apiUrl, setApiUrl] = useState("");
  const [loadingConfig, setLoadingConfig] = useState(true);
  const [categoryNames, setCategoryNames] = useState({});
  const [groupFilter, setGroupFilter] = useState("");
  const [tools, setTools] = useState([]);

  useEffect(() => {
    async function fetchConfig() {
      let url = await loadConfig();
      setApiUrl(url.APIURL);
      setLoadingConfig(false);
    }
    fetchConfig();
  }, []);

  useEffect(() => {
    if (!loadingConfig) {
      Promise.all([
        axios.get(`${apiUrl}/checks`, {
          headers: { accessToken: localStorage.getItem("accessToken") }
        }),
        axios.get(`${apiUrl}/tools`, {
          headers: { accessToken: localStorage.getItem("accessToken") }
        })
      ]).then(async ([checksResponse, toolsResponse]) => {
        setChecksObject(checksResponse.data);
        setTools(toolsResponse.data);
        // Fetch category names for all unique categoryIds
        const uniqueCategoryIds = Array.from(new Set(checksResponse.data.map(c => c.categoryId).filter(Boolean)));
        const names = {};
        await Promise.all(uniqueCategoryIds.map(async (catId) => {
          try {
            const res = await axios.get(`${apiUrl}/categories/${catId}`, {
              headers: { accessToken: localStorage.getItem("accessToken") }
            });
            names[catId] = res.data.name;
          } catch {
            names[catId] = "-";
          }
        }));
        setCategoryNames(names);
      });
    }
  }, [loadingConfig, apiUrl]);

  if (loadingConfig) {
    return <LoadingSpinner text="Lade Prüfungen..." />;
  }

  if (ChecksObject.length === 0) {
    return (
      <div className="container">
        <h1 className="my-4">Prüfliste</h1>
        <div className="alert alert-info">Keine Prüfungen vorhanden.</div>
      </div>
    );
  }

  return (
    <>
    <div className="container">
      <h1 className="my-4">Prüfliste</h1>
      <div className="mb-3 toolbar">
        <label htmlFor="groupFilter">Filter nach Gerätegruppe:</label>
        <select
          id="groupFilter"
          className="form-control toolbar-select"
          value={groupFilter}
          onChange={e => setGroupFilter(e.target.value)}
        >
          <option value="">Alle</option>
          {[...new Set(ChecksObject.map(check => {
            const tool = tools.find(t => t.id === check.ToolId);
            return tool?.ToolsGroup?.groupname;
          }).filter(Boolean))].sort((a, b) => a.localeCompare(b)).map((group, idx) => (
            <option key={idx} value={group}>{group}</option>
          ))}
        </select>
      </div>
      <table className="table table-stack">
        <thead>
          <tr>
            <th>Geprüftes Gerät</th>
            <th>Gerätegruppe</th>
            <th>Kategorie</th>
            <th>Prüfergebnis</th>
            <th>Prüfdatum</th>
          </tr>
        </thead>
        <tbody>
          {ChecksObject.filter(check => {
            const tool = tools.find(t => t.id === check.ToolId);
            const groupname = tool?.ToolsGroup?.groupname || "";
            const matchesGroup = groupFilter === "" || groupname === groupFilter;
            return matchesGroup;
          }).slice().sort((a, b) => new Date(b.checkdate) - new Date(a.checkdate)).map((value, key) => {
            const tool = tools.find(t => t.id === value.ToolId);
            return (
              <tr
                key={key}
                onClick={() => {
                  navigate(`/Check/${value.id}`);
                }}
                style={{ cursor: 'pointer' }}
              >
                <td data-label="Geprüftes Gerät">{value.Tool?.serialnumber || tool?.serialnumber || '-'}</td>
                <td data-label="Gerätegruppe">{tool?.ToolsGroup?.groupname || '-'}</td>
                <td data-label="Kategorie">{categoryNames[value.categoryId] || '-'}</td>
                <td data-label="Prüfergebnis">{value.checkresult}</td>
                <td data-label="Prüfdatum">{value.checkdate}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

    </div>
    </>
  );
}

export default Checks;
